export default "__VITE_ASSET__Dkoea7xn__"